import base from 'moodleDir/report/minobr/lib/ParsedReport.vue';


export default {
  routes: [
    {
      path: '/',
      component:base,
      name:'base'
    },
  ]
}
